import { Observable } from './Observable';

interface TimerStoreProps {
  delay: number; // in ms
}

export class TimerStore extends Observable {
  delay: number; // in ms
  _elapsedTime: number = 0; // in ms
  _tmpElapsed: number = 0; // in ms
  timeout: number | undefined;
  finished: boolean = false;
  startTimeout: number | undefined;

  constructor({ delay }: TimerStoreProps) {
    super();
    this.delay = delay;
  }

  pause(): void {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this._elapsedTime += this.startTimeout ? Date.now() - this.startTimeout : 0;
    this.startTimeout = undefined;

    this.notify('pause', { elapsedTime: this._elapsedTime });
  }

  resume(): void {
    if (this.isStarted) return;

    this.notify('resume');

    if (this.delay !== null && this.delay !== undefined && !this.finished) {
      this.timeout = setTimeout(() => {
        this.notify('finish');
        this.finished = true;
      }, this.delay - this._elapsedTime) as any;

      this.startTimeout = Date.now();
    }
  }

  finish(): void {
    this.notify('finish');

    this.pause();
    this.finished = true;
  }

  get isStarted(): boolean {
    return this.startTimeout !== undefined;
  }

  get isPaused(): boolean {
    return this.startTimeout === undefined;
  }

  get isFinished(): boolean {
    return this.finished;
  }

  get elapsedTime(): number {
    return this._elapsedTime;
  }
}
